<tec-list-layout>
	<tec-title-group [title]="'PROCESSES.TITLE' | translate">
		@if (rolePermissions.canLaunchWorkflowDemo()) {
			<tec-button [label]="'BUTTON.CREATE' | translate" type="secondary" (clickEvent)="showModalCreateProcess = true"/>
		}
	</tec-title-group>

	@if(alertError) {
		<tec-alert status="error" [msg]="alertError" (closeAlert)="alertError = ''" />
	}

	@if (hasReviewProcess) {
		<tec-alert
			[msg]="'PROCESSES.ALERT_PENDING' | translate"
			[buttonLabel]="'BUTTON.CHECK' | translate"
			(buttonClicked)="goToReviewProcess($event)"
			hiddenCloseButton
		></tec-alert>
	}

	<ng-container content>
		<tec-table-filter [selection]="{all: false, ids: []}">
			<div class="process-list__toolbar">
				<tec-toolbar
					[toolbar]="toolbar()"
					[maxFilter]="4"
					(formFilter)="filterChange($event)"
					(formFilterLive)="filterLiveChange($event)"
					(actionClick)="onToolbarAction($event)"
				></tec-toolbar>
				@if (showKoErrorCodeFilter()) {
					<div class="process-list__ko-error-filter">
						@if (errorCodeOptions.length) {
							<tec-select
								[options]="errorCodeOptions"
								[placeholder]="'FILTERS.ERROR_CODE_PLACEHOLDER' | translate"
								[search]="true"
								[allowDeselect]="true"
								[value]="selectedErrorCode"
								(valueChange)="onErrorCodeSelect($event)"
							/>
						}
						<tec-select
							[options]="operationTypeOptions"
							[placeholder]="'FILTERS.TYPE_PLACEHOLDER' | translate"
							[search]="true"
							[allowDeselect]="true"
							[multiple]="true"
							[value]="selectedOperationTypes"
							(valueChange)="onKoOperationTypeSelect($event)"
						/>
					</div>
				}
			</div>
			<tec-table
				[headers]="header"
				[rows]="content"
				[config]="config"
				(sortEvent)="sortChange($event)"
				(cellEvent)="tableCell($event)"
				(rowEvent)="tableRow($event)"
				(paginationChange)="paginationChange($event)"
			></tec-table>
		</tec-table-filter>
	</ng-container>
</tec-list-layout>

@if (showModalCreateProcess) {
	<app-modal-create-process (closeEvent)="showModalCreateProcess = false"></app-modal-create-process>
}

@if (curlModalOpen()) {
	<app-modal-curl-request
		[titleKey]="'PANEL.CURL_MODAL.TITLE_PROCESSES_LIST'"
		[curlText]="getProcessesListCurl()"
		(closeEvent)="closeCurlModal()"
	/>
}
